quoteModule.controller('quoteQueueController',
['$scope','$rootScope','$window', 'quoteCreationEvents', 'rateQuoteCoordService', '$q',
    'rateQuoteScenariosService','rateQuotePersistService','quoteContractRetrievalService','contractCreationService',
    'dealerPreferencesService','contractInfoService','$mdDialog','userAuthenticateService',
    'quoteIntegrationConstants','erateSessionVarsService','quoteIntegrationService','$interval',
    'financeService','TLCError','AppErrorCodes','quoteContractArchivalService','financeContractService','CustomerInfo', 'dealershipEvents','dealProductService',
    'vehicleProductsProcessingService', 'providerFeaturesService', 'imSessionVarsService', 'rateQuoteRetrievalCoordService',
function ($scope, $rootScope, $window, quoteCreationEvents, rateQuoteCoordService, $q,
      rateQuoteScenariosService, rateQuotePersistService, quoteContractRetrievalService, contractCreationService,
      dealerPreferencesService, contractInfoService, $mdDialog, userAuthenticateService,
      quoteIntegrationConstants, erateSessionVarsService, quoteIntegrationService, $interval,
      financeService, TLCError,AppErrorCodes, quoteContractArchivalService, financeContractService, CustomerInfo, dealershipEvents, dealProductService,
          vehicleProductsProcessingService, providerFeaturesService, imSessionVarsService, rateQuoteRetrievalCoordService) {

    var self = this;
    /*
    This controller has "morphed" into the "Contract Queue", but I chose not to rename the file. Based on the
    proposals set up, capture the quotes or contracts for a proposal (scenario).

    When we add or remove quotes, we will cast an event to save the quotes as well, so that any changes
    are persisted.
     */
    $scope.providerUsesProductType = false;

   //initialize the directive with the controller
    this.init = function (element) {
        self.$element = element;
        $scope.providerUsesProductType = dealerPreferencesService.providerUsesProductType();
    }

    //data to show in the view - only showing from current scenario
    $scope.quoteQueueInfo = contractInfoService.quoteQueueInfo;

    // for alternate financing
    var eligibility = [];
    $scope.financedQuoteStatus = {};
    $scope.showSIU = false;
    $scope.showSPP = false;
    $scope.dealerAltFinancingAllowed = false;
    $scope.haveEligibleProductForAltFinance = false;

    $scope.contractPerQuote = contractInfoService.contractsPerQuote;
    $scope.contractInfoForQuote = contractInfoService.contractInfo;
    $scope.allowCreateContract = contractCreationService.allowCreateNewContract;
    $scope.contractProcessing = contractCreationService.contractsProcessing;
    $scope.contractErrsForQuote = contractInfoService.contractErrMsgPerQuote;
    $scope.contractFatalForQuote = {};
    $scope.contractIsFatalForQuote = {};
    $scope.originalRetails = [];
    $scope.quoteModeQQ = null;
    $scope.menuQuoteIntegrated = quoteIntegrationConstants.menuQuoteIntegrated;
    $scope.menuContractIntegrated = quoteIntegrationConstants.menuContractIntegrated;
    $scope.createContractDisabled = true;
    $scope.vehicleData = rateQuoteCoordService.VehicleData;
    $scope.providerAllowsDraft = false;
    $scope.getSettingsDone = false;

    $scope.menuAutoCheckQuoteIds = [];
    $scope.menuInvalidDealQuoteIds = [];
    $scope.productsToReRateAfterDealChange = [];
    $scope.allowRetailBelowZero = false;//default to false

    $scope.init = function(){
        //$scope.allowRetailBelowZero = imSessionVarsService.getRetailBelowZero();
        $scope.quoteModeQQ = erateSessionVarsService.getQuotingMode();
        $scope.vehicleData = rateQuoteCoordService.VehicleData;
        $scope.financedQuoteStatus = {};
        $scope.showSIU = false;
        $scope.showSPP = false;
        financeService.clearQuotesToCalculate();
        $scope.dealerAltFinancingAllowed = erateSessionVarsService.getDealerAltFinanceEnabled();

        contractCreationService.providerAllowsDraft()
        .then(
            function allowsResult(res){
                $scope.providerAllowsDraft = res;
            }
        );
        dealProductService.getProductsReRateOnDealChange()
        .then(
            function gotProds(response){
                $scope.productsToReRateAfterDealChange = response;
            }
        );
        providerFeaturesService.getProviderApplicationSetting("AllowRetailBelowZero",'false')
        .then(
            function(element){
                $scope.allowRetailBelowZero = element.toString().toUpperCase() === "TRUE";
            }
        );

    }

    $scope.$on(quoteCreationEvents.vehicleDataChanged, function(event, args) {
        $scope.vehicleData = rateQuoteCoordService.VehicleData;
    });

    $scope.init();
    //show/hide
    $scope.toggleShowContracts = function(){
        $scope.quoteQueueInfo.showQueue = !$scope.quoteQueueInfo.showQueue;
    }
    //when we remove quotes, clear out data
    $scope.$on(quoteCreationEvents.removeCurrentQuotes, function(event, args) {
        contractInfoService.clearQuoteQueueInfo();
    });

    $scope.$on(dealershipEvents.dealerDisplayPreferencesComplete, function(event, args) {
        //When the flag is false, the price link is disabled, and we need to force calling the getCurrentQueuedRatesAndContracts, to get the Display Settings
        if ($scope.getSettingsDone == false) {
            $scope.getSettingsDone = true;
            $scope.getCurrentQueuedRatesAndContracts();
        }
    });
    //when we remove quotes, clear out data
    /*
    handled already
    $scope.$on(quoteCreationEvents.saveRatesToCompleted, function(event, args) {
        $scope.getCurrentQueuedRatesAndContracts();
    });
    */
    //get the current rates by scenario
    $scope.getCurrentQueuedRatesAndContracts = function(){
        //if we are in the process of saving quotes while we are trying to retrieve quotes, ignore
        if (rateQuotePersistService.getSaveInProgress())
            return;

        // reload product/clean queue ...
        if (vehicleProductsProcessingService.getForceLoadProducts()) return;
        
        $scope.quoteQueueInfo.currentScenarioId = rateQuoteScenariosService.getCurrentScenario();
        $scope.originalRetails = [];

        var quotes = rateQuoteCoordService.getRatesForScenarioCode($scope.quoteQueueInfo.currentScenarioId);

        //Some times quotes are retrieved to populate contract dash... lets see if we can get them from the scope
        if(quotes.length < 1){
            //$scope.loadScenarioQuotes();
            if($scope.scenarioInfo.scenarioQuotes && $scope.scenarioInfo.scenarioQuotes.length > 0)
            {
                quotes = $scope.scenarioInfo.scenarioQuotes;
            }
        }

        $scope.quoteQueueInfo.currentScenarioQuotes = quotes;
        $scope.quoteQueueInfo.currentScenarioContracts = [];//initialize
        quoteContractRetrievalService.initContractsCreated();

        financeService.getEligibleProductList(quotes)
        .then(
            function(eligibilityData) {
                eligibility = eligibilityData;
                $scope.haveEligibleProductForAltFinance = false;
                if (eligibility && eligibility.length > 0){
                    eligibility.forEach(function(elig){
                        $scope.haveEligibleProductForAltFinance |= elig.eligible && $scope.dealerAltFinancingAllowed;

                        // financeContractService.getAltFinancingMode()
                        //     .then(
                        //         function (financingMode) {
                        //             if (financingMode == "POST-CONTRACT-MODE") {
                        //                 $scope.showSPP = true;
                        //             }
                        //             else if (financingMode == "PRE-CONTRACT-MODE") {
                        //                 $scope.showSPP = false;
                        //             }
                        //         });

                        //Eligibility check for Zurich SPP-token
                        if (elig.eligible && elig.QuoteSaveSPPToken) {
                            $scope.showSPP = true;
                            $scope.showSIU = false;
                            $scope.haveEligibleProductForAltFinance = false;

                            //Save SPP Token
                            var currentQuotes = rateQuoteCoordService.getQuotesByScenarioId(
                                rateQuoteScenariosService.getCurrentScenario());

                            currentQuotes.forEach(
                                function gatherQuotesToUpdate(nextQuote){
                                    if (quoteId(nextQuote) && !isNaN(quoteId(nextQuote)) && quoteId(nextQuote) == elig.QuoteId) {
                                        nextQuote.RatedTerms[0].PartnerSpecificFields.FlexFields.push(
                                            {
                                                "FieldName": "QuoteSave-SPPToken",
                                                "FieldValue": elig.QuoteSaveSPPToken
                                            });

                                        rateQuotePersistService.saveRatesAsQuotes();
                                    }
                                }
                            );
                        }
                        // else
                        // {
                        //     $scope.showSPP = false;
                        // }
                    });
                }
            },
            function(err){
                //do nothing...
            }
        )
        .then(
        function(){
            if (!(quotes && quotes.length > 0)){
                $scope.quoteQueueInfo.currentScenarioQuotes = [];
                $scope.quoteQueueInfo.statuses = {};
                contractCreationService.clearContractsChecks();//no quotes, so no contracts either
                quotes = null;
            }
            else {
                //finding the contracts by quotes
                var quoteIds = [];
                quotes.forEach(function (qt) {
                    if (quoteId(qt) && !isNaN(quoteId(qt)))
                        quoteIds.push(parseInt(quoteId(qt)));
                });

                if (quoteIds.length > 0) {
                    quoteContractRetrievalService.getContractsByQuoteIds(quoteIds, false)
                    .then(
                        function setContractsDataFromQuotes(contractReturn) {
                            $scope.contractPerQuote = contractInfoService.contractsPerQuote;
                            $scope.contractInfoForQuote = contractInfoService.contractInfo;
                            $scope.contractErrsForQuote = contractInfoService.contractErrMsgPerQuote;
                            $scope.quoteQueueInfo.currentScenarioContracts = contractReturn && contractReturn.length > 0 ? contractReturn.map(function (ct) {
                                return ct.contractId;
                            }) : [];

                            quoteIds.forEach(function setupContractStatusAndUrl(quoteId) {
                                $scope.contractFatalForQuote[quoteId] = false;
                                $scope.contractIsFatalForQuote[quoteId] = false;
                                if($scope.quoteModeQQ == $scope.menuContractIntegrated) {
                                    //we will auto-check official for those quotes sent via Menu
                                    if (_.indexOf($scope.menuAutoCheckQuoteIds, quoteId)>=0 &&
                                        _.indexOf($scope.menuInvalidDealQuoteIds,quoteId)<0){
                                        $scope.quoteQueueInfo.statuses[quoteId].officialChecked = true;
                                        $scope.changeContractStatus(quoteId);
                                    }
                                    else{
                                        // COM-807/COM-808
                                        //otherwise we will see if the quote is not valid because of deal change ->
                                        // if not then just show that we aren't selecting this quote for contracting
                                        var noContractMsg = {type: 'info', message: 'Not Selected for Contracting.'};
                                         if (_.indexOf($scope.menuInvalidDealQuoteIds,quoteId)>=0){
                                            noContractMsg = {type: 'error', message: 'Deal Financials Have Changed. Please Re-Rate.'};
                                             $scope.contractIsFatalForQuote[quoteId] = true;
                                         }
                                         $scope.contractErrsForQuote[quoteId] = noContractMsg;
                                        $scope.contractFatalForQuote[quoteId] = true;
                                         $scope.quoteQueueInfo.statuses[quoteId].draftChecked =
                                             $scope.quoteQueueInfo.statuses[quoteId].officialChecked = false;
                                     }
                                }
                                else {
                                    if ($scope.contractPerQuote[quoteId]) {
                                        var aURL = $scope.contractPerQuote[quoteId][0];

                                            $scope.quoteQueueInfo.statuses[quoteId].officialChecked = $scope.contractInfoForQuote[aURL].status === 'OFFICIAL';
                                            $scope.quoteQueueInfo.statuses[quoteId].draftChecked = $scope.contractInfoForQuote[aURL].status === 'DRAFT';
                                            $scope.quoteQueueInfo.statuses[quoteId].sppChecked = $scope.contractInfoForQuote[aURL].status === 'SPP';
                                        }
                                }
                            });
                        },
                        function (err) {
                            throw new Error(err);
                        }
                    );
                }

                $scope.quoteQueueInfo.currentScenarioQuotes.forEach(function (quote) {

                    $scope.quoteQueueInfo.allowContracting[quoteId(quote)] = false;
                    
                    $scope.originalRetails[quote.RatedProduct.InternalProductId] = quote.RatedTerms[0].RetailCost;

                    if (quoteId(quote) && $scope.quoteQueueInfo.statuses[quoteId(quote)] == undefined) {
                        $scope.quoteQueueInfo.statuses[quoteId(quote)] = {
                            "draftChecked": false,
                            "officialChecked": false,
                            "sppChecked": false
                        };
                    }

                    //Several events call this function, sometimes the Preferences haven't been loaded, hence the settings are retrieved as null
                    dealerPreferencesService.getProductDisplayPreferences($scope.providerUsesProductType ? quote.RatedProduct.ParentProductType.InternalProductTypeId : quote.RatedProduct.InternalProductId, quote.RatedProduct.ParentProductType.InternalProductTypeId, rateQuoteCoordService.VehicleData.dateOfSale)
                        .then(
                            function setProfitCostModeBySetting(settings) {
                                //When settings are retrieved as null (haven't finished loading), we need to set the flag of getSettingsDone as false, in order to disable the price link, and to force calling this function again
                                if (settings == null || settings == 'undefined'){
                                    $scope.getSettingsDone = false;
                                }
                                $scope.quoteQueueInfo.profitCostMode[quote.RatedProduct.InternalProductId] = settings;
                            },
                            function (err) {
                                throw new TLCError(new Error(err), AppErrorCodes.QuoteQueueController_GeneralError);
                            }
                        )


                    contractCreationService.canCreateContractForQuote(quoteId(quote))
                    .then(
                        function gotCreationMode(mode){
                            $scope.quoteQueueInfo.allowContracting[quoteId(quote)] = mode;
                        }
                    );
                });
            }

            quotes = null;
            $scope.refreshContractLinks();
        });
    };

    //respond to refresh quote queue event
    $scope.$on(quoteCreationEvents.saveRatesToCompleted, function(event, args) {
        financeService.clearHeldFinancedQuotes();
        $scope.getCurrentQueuedRatesAndContracts();
    });

    //respond to refresh quote queue event
    $scope.$on(quoteCreationEvents.refreshQuoteQueue, function(event, args) {
        $scope.getCurrentQueuedRatesAndContracts();
    });

    //respond to changing the proposal
    $scope.$on(quoteCreationEvents.scenarioChanged, function(event, args) {
        $scope.getCurrentQueuedRatesAndContracts();
    });

    //need to base this on the settings
    $scope.getModifyRetailAllowed = function(productCategoryCode){
        return true;
    }
    $scope.editingPriceMode = function(productCategoryCode){
        productCategoryCode = productCategoryCode.toUpperCase();
        var priceEditing = $scope.quoteQueueInfo.priceEditing[$scope.quoteQueueInfo.currentScenarioId];
        return priceEditing ? priceEditing[productCategoryCode] : false;
    }
    $scope.toggleEditingPriceMode = function(productCategoryCode, rateId){
        productCategoryCode = productCategoryCode.toUpperCase();
        var currentScenarioId = $scope.quoteQueueInfo.currentScenarioId;
            if (!$scope.quoteQueueInfo.priceEditing[currentScenarioId]) {
                $scope.quoteQueueInfo.priceEditing[currentScenarioId] = {};
            }
           $scope.quoteQueueInfo.priceEditing[currentScenarioId][productCategoryCode] = !$scope.quoteQueueInfo.priceEditing[currentScenarioId][productCategoryCode];
    }
    //need to base this on the settings
    $scope.getShowProfitCost = function(productCategoryCode){
        return true;
    };

    //double-check that they didn't reduce below remit
    $scope.changeRetail = function(rate, previousAmount){
        var retailCost = rate.RatedTerms[0].RetailCost;
        var maxRetail = rate.RatedTerms[0].MaxRetailCostAllowed > 0 ? rate.RatedTerms[0].MaxRetailCostAllowed : 999999.0;
        var dealerCost = rate.RatedTerms[0].DealerCost;
        var internalProductId = rate.RatedProduct.InternalProductId;
        var originalRetail = angular.isDefined($scope.originalRetails[internalProductId])
                ? $scope.originalRetails[internalProductId]
                : false;

        // if(retailCost < dealerCost || retailCost > maxRetail|| !$scope.allowRetailBelowZero) {
        if( (retailCost < dealerCost && !$scope.allowRetailBelowZero) || retailCost > maxRetail ) {
            rate.RatedTerms[0].RetailCost = originalRetail !== false
                ? originalRetail
                : previousAmount;
        }
        rateQuoteRetrievalCoordService.endQuoteRetrieval();
        $rootScope.$broadcast(quoteCreationEvents.attemptQuoteSave,{});
    };
    $scope.updatePrice = function (rate, previousAmount) {
        $scope.changeRetail(rate, previousAmount);
        $scope.toggleEditingPriceMode(
            rate.RatedProduct.ParentProductType.ParentProductRatingCategory.ApplicationCode,
            quoteId(rate)
        );
    }
    $scope.cancelRate = function(rate) {
        $scope.toggleEditingPriceMode(
            rate.RatedProduct.ParentProductType.ParentProductRatingCategory.ApplicationCode,
            quoteId(rate)
        );
    };

    function removeOneRateFromQueue(rate, uncheck)
    {
        rate.softDelete = true;
        rateQuotePersistService.removeQuoteOnScenario(rateQuoteScenariosService.getCurrentScenario(),
            rate.RatedProduct.ParentProductType.ParentProductRatingCategory.ApplicationCode.toUpperCase())
            .then(
                function successfullyRemovedQuote(data){
                    financeService.removeQuoteFromCalculation(quoteId(rate));

                    $rootScope.$broadcast(quoteCreationEvents.refreshQuoteQueue,{reRate : false, prodId: rate.RatedProduct.InternalProductId});
                    //$rootScope.$broadcast(quoteCreationEvents.attemptQuoteSave,{});
                    $rootScope.$broadcast(quoteCreationEvents.quoteRemovedFromScenario,{});
                    if (uncheck) $scope.$broadcast(quoteCreationEvents.unCheckForceLoading, {});
                },
                function(err){
                    rate.softDelete = false;
                    throw new TLCError(new Error(err),AppErrorCodes.QuoteQueueController_GeneralError);
                }
            );
    }

    //remove a quote from current scenario
    $scope.removeQuoteFromQueue = function(rate){
        removeOneRateFromQueue(rate, false);
        $scope.clearPrFltCustomFields(rate);
    }

    $scope.$on(quoteCreationEvents.cleanRatesFromQueue, function(event, args){
        dealProductService.setInCleanQueueProcess(true);
        var rates = $scope.quoteQueueInfo.currentScenarioQuotes;
        contractInfoService.clearQuoteQueueInfo();
        var i = 0;
        var uncheck = false;
        rates.forEach(function(rate){
            i++;
            uncheck = (i >= rates.length);
            removeOneRateFromQueue(rate, uncheck);
        });
    });

    //loading an existing quote - so get the rates and contracts
    $scope.$on(quoteCreationEvents.loadingExistingQuote, function(event, args) {
        //$scope.getCurrentQueuedRatesAndContracts();

        $scope.checkMenuContractIntegration();

        $scope.contractsExpanded = true;
    });
    //clearing out the products when we start a new quote
    $scope.$on(quoteCreationEvents.startNewProductQuote, function(event, args) {
        $scope.quoteQueueInfo = null;
        $scope.quoteQueueInfo = contractInfoService.quoteQueueInfo
        $scope.contractPerQuote = null;
        $scope.contractPerQuote = contractInfoService.contractsPerQuote;
        $scope.contractInfoForQuote = null;
        $scope.contractInfoForQuote = contractInfoService.contractInfo;
        $scope.contractErrsForQuote = null;
        $scope.contractErrsForQuote = contractInfoService.contractErrMsgPerQuote;
        rateQuoteCoordService.initHeldQuotes();
        contractInfoService.clearContractProductInfo();
    });

    $scope.createOfficialContract = function(quoteId) {
        contractCreationService.createOfficialContract(quoteId)
            .then(function() {
                //do nothing
            }, function(err) {
                throw new TLCError(new Error(err),AppErrorCodes.QuoteQueueController_ContractError);
            });
    };


    $scope.createOfficialWithAltPayment = function(quoteId) {
        //first remove all "draft" contracts for this quoteid
        var encQuoteIds = [quoteId].map(function(quoteId) { return rateQuotePersistService.getEncryptedQuoteId(quoteId); });
        quoteContractArchivalService.archiveContractsForQuote([quoteId],encQuoteIds)
        .then(
            function(contractArchivedYN){

                financeContractService.getContractNumber(quoteId)
                .then(function (contractNumber) {
                    // returned contract number should be null if provider does not support requesting a specific contract number
                    financeContractService.buildFinancingContractUrl(contractNumber)
                        .then(function (url) {
                            contractInfoService.quoteQueueInfo.bankInfoRequired[quoteId] = url;//will set up values later
                            contractCreationService.setContractNumber(quoteId, contractNumber);

                            //second, flag creation status to "OFFICIAL"
                            contractCreationService.setCreationStatus(quoteId, 'OFFICIAL');
                            //this should show the payment info button
                            $scope.openFinancingWindow($scope.quoteQueueInfo.bankInfoRequired[quoteId], quoteId)
                        });
                });
            }
        )
    };

    $scope.changeContractStatus = function(quoteid){
        // Changes state info about contract, based on what UI says.
        var contractUrl = $scope.contractPerQuote[quoteid];
        if (contractUrl){
            if (angular.isArray(contractUrl))
                contractUrl = contractUrl[0];//only need the first one
            var contractInfo = $scope.contractInfoForQuote[contractUrl];
            var stat = contractInfo.status;
            if (stat && stat === 'OFFICIAL') {
                contractCreationService.clearACreationStatus(quoteid);
                //we've already got an official contract for this quote, so we
                // don't want to resubmit the quote for a contract
                return;
            }
        }
        var stat = $scope.quoteQueueInfo.statuses[quoteid].draftChecked ? 'DRAFT' : ($scope.quoteQueueInfo.statuses[quoteid].officialChecked ? 'OFFICIAL' : null);
        contractCreationService.setCreationStatus(quoteid, stat);
    }

    $scope.changeContractStatusSPP = function(quoteid){
        // Changes state info about contract, based on what UI says.
        var contractUrl = $scope.contractPerQuote[quoteid];
        if (contractUrl){
            if (angular.isArray(contractUrl))
                contractUrl = contractUrl[0];//only need the first one
            var contractInfo = $scope.contractInfoForQuote[contractUrl];
            var statSpp = contractInfo.status;
        }
        var statSpp = $scope.quoteQueueInfo.statuses[quoteid].sppChecked ? 'SPP' : null;
        contractCreationService.setCreationStatusSPP(quoteid, statSpp);
    }

    $scope.$watch('quoteQueueInfo.selectedQuotes', function() {
        $scope.refreshContractLinks();
    });

    $scope.displayContract = function(urls, contractId, _quoteId){
        var urls = angular.isArray(urls) ? urls : [urls]

        var authParam = {
            "auth": userAuthenticateService.getUserToken()
        }

        // add authorization as qs param.  Note that payment agreement urls already have a qs param for contract type.
        var authedUrls = urls.map(function(url) { return URI(url).addSearch(authParam).toString();  });
        var url = authedUrls.pop();
        var financingWindow = window.open(url, 'FinancingWindow');
        var _updatedlink = '';
        var refreshPromises = [];
        var deferred = $q.defer();

        var stop = $interval(function () {
            if (financingWindow.closed) {
                $interval.cancel(stop);

                if (contractId && !url.toString().includes("PaymentFinal")) {
                    authedUrls = null;
                    var _contractIDs = '';
                    for (var i = 0; i < $scope.quoteQueueInfo.currentScenarioContracts.length; i = i + 1) {
                        _contractIDs += _contractIDs == '' ? $scope.quoteQueueInfo.currentScenarioContracts[i] : ';' + $scope.quoteQueueInfo.currentScenarioContracts[i];
                    }

                    //rateQuoteCoordService.getQuoteSessionId().toString()
                    financeContractService.getAltFinancingStatus(imSessionVarsService.getCurrentProviderCode(), rateQuoteCoordService.getQuoteSessionId().toString(), _quoteId)
                        .then(
                            function (status) {
                                //save updated url if true
                                if (status) {
                                    var finalContractIds = _contractIDs.split(';');
                                    for (var i = 0; i < finalContractIds.length; i++) {
                                        var _updatedLink = financeContractService.UpdateAltFinancingLink(finalContractIds[i], _quoteId);
                                        refreshPromises.push(_updatedLink);

                                        // financeContractService.UpdateAltFinancingLink(finalContractIds[i], _quoteId)
                                        //     .then(
                                        //         function (_updatedspplink) {
                                        //             _updatedlink = _updatedspplink;
                                        //             // var _sppLink = $scope.contractPerQuote[_quoteId][1];
                                        //             $scope.contractPerQuote[_quoteId][1] = _updatedspplink;
                                        //             // $scope.contractInfoForQuote[_sppLink].formName = "Payment-Link";
                                        //             // $scope.refreshContractLinks();
                                        //         });
                                    }

                                    $q.all(refreshPromises)
                                        .then(
                                            function (_response) {
                                                var quotes = rateQuoteCoordService.getQuotesByScenarioId(rateQuoteScenariosService.getCurrentScenario());
                                                var quoteIds = [];
                                                quotes.forEach(function (qt) {
                                                    if (quoteId(qt) && !isNaN(quoteId(qt)))
                                                        quoteIds.push(parseInt(quoteId(qt)));
                                                });

                                                if (quoteIds.length > 0) {
                                                    quoteContractRetrievalService.getContractsByQuoteIds(quoteIds, false)
                                                        .then(
                                                            function setContractsDataFromQuotes(contractReturn) {
                                                                $scope.contractPerQuote = contractInfoService.contractsPerQuote;
                                                                $scope.contractInfoForQuote = contractInfoService.contractInfo;
                                                                $scope.contractErrsForQuote = contractInfoService.contractErrMsgPerQuote;
                                                            });
                                                }

                                                deferred.resolve(_response);
                                            },
                                            function (_errors) {
                                                deferred.reject(_errors);
                                            }
                                        )
                                }
                            });
                }
                else {
                    authedUrls = null;
                    $interval.cancel(stop);
                    stop = null;
                }
            }
        }, 100);

        return deferred.promise;
    }

    $scope.$on("__local_open_win", function(event, args) {
        var newWin = $window.open(args.url, args.tab);
    });

    $scope.refreshContractLinks = function(){
        $scope.contractPerQuote = contractInfoService.contractsPerQuote;
        $scope.contractInfoForQuote = contractInfoService.contractInfo;
        $scope.allowCreateContract = contractCreationService.allowCreateNewContract;
        $scope.contractErrsForQuote = contractInfoService.contractErrMsgPerQuote;
    }

    $scope.allRequiredFieldsFilled = function() {
        return contractCreationService.allRequiredFieldsFilled(
            rateQuoteCoordService.CustomerData,
            contractInfoService.contractProductInfo,
            rateQuoteCoordService.DealData,
            rateQuoteCoordService.LenderData.selectedLender,
            rateQuoteCoordService.VehicleData);
    }

    $scope.showSIUCalculator = function(event) {
        $scope.showSIU = true;
        financeService.clearHeldFinancedQuotes();
        var quoteInfoList = $scope.quoteQueueInfo.currentScenarioQuotes
            .filter(function(quote) {
                // only products that are eligible AND are not already being calculated
                return eligibility
                        .filter(function(data) { return data.eligible; })
                        .map(function(data) { return data.productId; })
                        .indexOf(quote.RatedProduct.InternalProductId) >= 0
                    && !financeService.getFinancedQuoteInfoById(quoteId(quote));
            }).map(function(quote){
            return {
                name : quote.RatedProduct.ParentProductType.ApplicationCode,
                cost : quote.RatedTerms[0].RetailCost,
                id : quoteId(quote),
                terms : eligibility.filter(function(data) { return data.productId == quote.RatedProduct.InternalProductId })[0].terms
            };
        });

        quoteInfoList.forEach(function(quoteInfo) {
            financeService.addQuoteForCalculation(quoteInfo);
            addFinanceAcceptanceWatcher(quoteInfo.id);
        });

        $mdDialog.show( {
            templateUrl: 'app/modules/finance/views/alt-finance-dialog.html',
            preserveScope: false,
            controller: 'financeCalculatorController'
        });

        event.stopPropagation();
    };

    var addFinanceAcceptanceWatcher = function(quoteId) {
        $scope.$watch(function financingWatchFn() {
            var fQuote = financeService.getFinancedQuoteInfoById(quoteId);
                if(fQuote && fQuote.financingInfo)
                    return fQuote.financingInfo.accepted;
                else
                    return null;
            },

            function financeAcceptanceChangedFn(newValue, oldValue) {
                if (newValue === oldValue) {
                    return; // this should be redundant
                }
                //$scope.quoteQueueInfo.statuses[quoteId].draftChecked = false;  // Always!
                //$scope.quoteQueueInfo.statuses[quoteId].officialChecked = newValue;   // i.e. official contract if and ONLY if finance calculation was accepeted
                $scope.changeContractStatus(quoteId);
                $scope.createContractDisabled = !$scope.checkQuoteStatusesSelected();
                rateQuotePersistService.saveRatesAsQuotes();
            });
    };


    var displayPreflight = function(error) {

        $mdDialog.show( {
            templateUrl: 'app/modules/quote/views/preflight-dialog.html',
            scope: $scope,
            preserveScope: true,
            locals: { error: error },
            bindToController: true,
            controller: 'quoteContractInfoController'

        });
    };

    $scope.showProfitHoverIn = function() {
        $scope.showProfitOnHover = true;
    };
    $scope.showProfitHoverOut = function() {
        $scope.showProfitOnHover = false;
    };

    $scope.checkMenuContractIntegration = function(){
        var integrationData;

        if ($scope.quoteModeQQ == $scope.menuContractIntegrated){
            var financialData = null;

            //COM-807
            //We are no longer removing all quotes except those to be contracted.
            // The reason is if the customer changes his/her mind, the user is forced
            // to re-create the deal
            //
            quoteIntegrationService.getIntegratedQuotesToContract()
            .then(
                function gotIntegrationData(quotesToContractData) {
                    integrationData = quotesToContractData;
                    $scope.setScenario(parseInt(quotesToContractData.quoteScenario));

                    //now we have removed all other scenarios.. Remove quotes not in list
                    $scope.currentQuotes = rateQuoteCoordService.getQuotesByScenarioId(
                        rateQuoteScenariosService.getCurrentScenario());
                    var chosenIntegrationQuotes = integrationData.allQuoteInfo;
                    var delPromises = [];

                    var newFinanceData = quoteIntegrationService.getIntegratedFinancialData();
                    var newCustData = quoteIntegrationService.getIntegratedCustomerData();
                    
                    //menu can change financial data (amount financed usually) or customer data (address, etc.)

                    // NEW : keeping "retrieved" deal data to compare when doing
                    //  menu contract integration
                    //checking if menu changed deal data from original quote
                    var oldDealData = rateQuoteCoordService.RetrievedDealData;
                    var dealChanged = false;
                    //var saveForGapFL = false

                    dealChanged |= parseInt(newFinanceData.financingMonths ? newFinanceData.financingMonths : '0') != parseInt(oldDealData.termMonths ? oldDealData.termMonths : '0');
                    dealChanged |= parseFloat(newFinanceData.financingAPR ? newFinanceData.financingAPR : '0.0') != parseFloat(oldDealData.financeRate ? oldDealData.financeRate : '0.0');
                    dealChanged |= parseFloat(newFinanceData.sellingPrice ? newFinanceData.sellingPrice : '0.0') != parseFloat(oldDealData.sellingPrice ? oldDealData.sellingPrice : '0.0');

                    //update financial data
                    rateQuoteCoordService.DealData.amountFinanced = newFinanceData.amountFinanced ? newFinanceData.amountFinanced : rateQuoteCoordService.DealData.amountFinanced ;

                    rateQuoteCoordService.DealData.termMonths = newFinanceData.financingMonths ? newFinanceData.financingMonths : rateQuoteCoordService.DealData.termMonths;
                    rateQuoteCoordService.DealData.financeRate = newFinanceData.financingAPR ? newFinanceData.financingAPR : rateQuoteCoordService.DealData.financeRate;
                    rateQuoteCoordService.DealData.daysToFirst = newFinanceData.daysToFirst ? newFinanceData.daysToFirst : rateQuoteCoordService.DealData.daysToFirst;
                    rateQuoteCoordService.DealData.saleType = newFinanceData.saleType ? newFinanceData.saleType : rateQuoteCoordService.DealData.saleType;
                    rateQuoteCoordService.DealData.sellingPrice = newFinanceData.sellingPrice ? newFinanceData.sellingPrice : rateQuoteCoordService.DealData.sellingPrice;
                    rateQuoteCoordService.DealData.MSRP = newFinanceData.vehicleMSRP ? newFinanceData.vehicleMSRP : rateQuoteCoordService.DealData.vehicleMSRP;

                    //update customer data
                    rateQuoteCoordService.CustomerData = new CustomerInfo();
                    if (newCustData.businessName){
                        rateQuoteCoordService.CustomerData.BusinessInfo.businessName = newCustData.businessName || '';
                        rateQuoteCoordService.CustomerData.BusinessInfo.driverFirstName = newCustData.primaryDriverFirstName || '';
                        rateQuoteCoordService.CustomerData.BusinessInfo.driverLastName = newCustData.primaryDriverLastName || '';
                        rateQuoteCoordService.CustomerData.phone1 = newCustData.phone || '';
                        rateQuoteCoordService.CustomerData.address1 = newCustData.address1 || '';
                        rateQuoteCoordService.CustomerData.address2 = newCustData.address2 || '';
                        rateQuoteCoordService.CustomerData.city = newCustData.city || '';
                        rateQuoteCoordService.CustomerData.state = newCustData.state || '';
                        rateQuoteCoordService.CustomerData.zip = newCustData.zip || '';
                    }
                    else{
                        rateQuoteCoordService.CustomerData.BuyerInfo.firstName = newCustData.firstName || '';
                        rateQuoteCoordService.CustomerData.BuyerInfo.middleName = newCustData.middleName || '';
                        rateQuoteCoordService.CustomerData.BuyerInfo.lastName = newCustData.lastName || '';
                        rateQuoteCoordService.CustomerData.address1 = newCustData.address1 || '';
                        rateQuoteCoordService.CustomerData.address2 = newCustData.address2 || '';
                        rateQuoteCoordService.CustomerData.city = newCustData.city || '';
                        rateQuoteCoordService.CustomerData.state = newCustData.state || '';
                        rateQuoteCoordService.CustomerData.zip = newCustData.zip || '';
                        rateQuoteCoordService.CustomerData.phone1 = newCustData.phone || '';
                    }
                    if(newCustData.coBuyerInfo) {
                        rateQuoteCoordService.CustomerData.CoBuyerInfo.firstName = newCustData.coBuyerInfo.firstName || '';
                        rateQuoteCoordService.CustomerData.CoBuyerInfo.middleName = newCustData.coBuyerInfo.middleName || '';
                        rateQuoteCoordService.CustomerData.CoBuyerInfo.lastName = newCustData.coBuyerInfo.lastName || '';
                    }
                    $scope.currentQuotes.forEach(
                        function gatherQuotes(nextQuote) {
                            var findQuote = chosenIntegrationQuotes.filter(
                                function (intQuote) {
                                    if (!intQuote)
                                        return false;
                                    return parseInt(intQuote.internalQuoteId) == parseInt(quoteId(nextQuote));
                                });
                            if (findQuote.length > 0) {
                                //quote is to be contracted, so make sure retail price is set
                                var newPrice = parseFloat(findQuote[0].negotiatedPrice);
                                nextQuote.RatedTerms[0].RetailCost = newPrice;
                                $scope.menuAutoCheckQuoteIds.push(parseInt(quoteId(nextQuote)));
                            }
                            if (dealChanged == 1) {
                                var prodsToRerate = $scope.productsToReRateAfterDealChange;
                                var rerateMe = false;
                                //if the deal changed and we need to re-rate it, the invalidate that quote
                                _.forEach(prodsToRerate, function (prodtype) {
                                    if (prodtype.ApplicationCode.toUpperCase() == nextQuote.RatedProduct.ParentProductType.ApplicationCode.toUpperCase()
                                        &&
                                        $scope.menuAutoCheckQuoteIds.indexOf(parseInt(quoteId(nextQuote))) >= 0) {

                                        $scope.menuInvalidDealQuoteIds.push(parseInt(quoteId(nextQuote)));
                                    }
                                });
                            }
                        }
                    );
                    $scope.currentQuotes = null;
                    chosenIntegrationQuotes = null;
                    //we will no longer auto-save when coming from Menu integration (contract)
                    // this should happen when we initially start the contract
                    // (interferes with deal info "check")
                }
            )
        }
    }

    $scope.contractsExpanded = false;

    $scope.toggleContractsExpanded = function ($event) {
        if($event.target.id != 'createContracts'){
            $scope.contractsExpanded = ! $scope.contractsExpanded;
        }
    }

    $scope.beginContractingForQuotes = function(){
        //
        //we are going to start by saving the quotes in the
        // current state before starting contracting
        //
        rateQuotePersistService.saveRatesAsQuotes()
        .then(
            function saveDone() {
                contractCreationService.beginContractForChosenQuotes($scope.quoteModeQQ == $scope.menuContractIntegrated)
                .then(
                function checkPreFlightOrContractsCreated(ok){
                    //debugger;
                    displayPreflight();
                })
            },
            function(err){
                displayPreflight(err);
                throw new TLCError(new Error(err),AppErrorCodes.QuoteQueueController_ContractError);
            }
        );
    }

    $scope.checkQuoteStatusesSelected = function(){
        var statuses = $scope.quoteQueueInfo.statuses;

        if ( !Object.keys(statuses).length ) { $scope.contractsExpanded = false; return false; }

        var somethingIsChecked = false;
        for ( var id in statuses ) {
            if(statuses.hasOwnProperty(id)) {
                if (contractCreationService.getCreationStatus(id))
                    somethingIsChecked = somethingIsChecked || _.values(statuses[id]).reduce(function(prev, current) { return prev || current; });
            }
        }
        //We have selected a rate to quote, show in contracts Dash 
        $scope.contractsExpanded = true;
        return somethingIsChecked;
    }

    $scope.$watch('quoteQueueInfo', function(){
        $scope.createContractDisabled = ! $scope.checkQuoteStatusesSelected();
    }, true);

    $scope.showPriceEditorLink = function(nextRate) {
        return (displayProfitAndCost(nextRate) || profitCostModeCanRetailBeModified(nextRate)) || ratedTermCanRetailBeModified(nextRate);
    }

    function displayProfitAndCost(nextRate) {
        var profitCostMode = $scope.quoteQueueInfo.profitCostMode[nextRate.RatedProduct.InternalProductId];
        return profitCostMode ? profitCostMode.displayProfitAndCost === 'ALWAYS' : false;
    }

    function profitCostModeCanRetailBeModified(nextRate) {
        var profitCostMode = $scope.quoteQueueInfo.profitCostMode[nextRate.RatedProduct.InternalProductId];
        return profitCostMode ? profitCostMode.allowModifyRetail === 'true' : false;
    }

    function ratedTermCanRetailBeModified(nextRate) {
        return nextRate.RatedTerms[0].CanRetailBeModified;
    }

    $scope.isEligibleForFinancing = function(productId) {
        if (!$scope.dealerAltFinancingAllowed) return false;
        return eligibility.filter(function(data) {
            return data.productId == productId && data.eligible;
        }).reduce(function(prev, curr) { return curr.eligible || prev; }, false);
    };

    $scope.getAltFinancingInfo = function(quoteId) {
        return financeService.getFinancedQuoteInfoById(quoteId);
    };

    $scope.AltFinancingMode = function() {
        return financeContractService.getAltFinancingMode();
    };

    $scope.AltFinancingStatus = function(contractId, quoteId) {
        return financeContractService.getAltFinancingStatus(imSessionVarsService.getCurrentProviderCode(), contractId, quoteId);
    };

    $scope.showQuoteCard = function(quoteId) {
        return !($scope.contractPerQuote[quoteId] != null ||
            $scope.quoteQueueInfo.loading[quoteId] ||
            $scope.quoteQueueInfo.bankInfoRequired[quoteId]);
    };

    $scope.showLoadingCard = function(quoteId) {
        return !!($scope.quoteQueueInfo.loading[quoteId] && !$scope.contractProcessing.started);
    };

    $scope.showBankInfoRequiredCard = function(quoteId) {
          return !!($scope.quoteQueueInfo.bankInfoRequired[quoteId]);
    };

    $scope.openFinancingWindow = function(url, quoteId) {
        var financingWindow = $window.open(
            url, "siuPREM",
            "height=800px,width=1024px,status=0,toolbar=0,menubar=0,resizable=1,location=0,scrollbars=1,dependent=1"
        );

        var poll = $interval( function() {
            if (financingWindow.closed) {
                $interval.cancel(poll);

                contractInfoService.quoteQueueInfo.bankInfoRequired[quoteId] = false;
                contractCreationService.createOfficialContract(quoteId)
                    .then(
                        function officialCreated(done){
                            //do nothing, we are good
                        },
                        function officialErr(err){
                            displayPreflight(err);
                            throw new TLCError(new Error(err),AppErrorCodes.QuoteQueueController_ContractError);
                        }
                    );
            }
        }, 500);

    }

    $scope.quoteId = quoteId;  // NOTE: This is a function

    function quoteId(quoteObjFromServer) {
       // This is used all over the place. It really should be available as a property of quoteObjFromServer.
       // But we have no client side model for that, so it is available here as both a local (private) function, and via $scope.
       return quoteObjFromServer.RatedTerms[0].SavedRateUniqueId;
    }

    $scope.checkVehicleTypeVinOk = function(){
        if ($scope.vehicleData.vehicleType == 'AUTO'){
            return ($scope.vehicleData.vin && $scope.vehicleData.vin.length > 0)
        }else{
            return true; //VIN not required for RVs
        }
    }

    function CheckGap() {
        var isProdGap = false;

        for (i = 0; i < $scope.currentQuotes.length; i++) {
            if(($scope.currentQuotes[i].RatedProduct.DisplayName.toUpperCase().indexOf('GAP') > -1)
                ||   (($scope.currentQuotes[i].RatedProduct.PartnerCode != null)
                    && ($scope.currentQuotes[i].RatedProduct.PartnerCode.toUpperCase().indexOf('GAP') > -1)))
            {
                isProdGap = true;
                break;
            }

        }
        return isProdGap;
    }

    function getProviderDealerAmtFinStates() {
        var states =[];
        var  dealerStates = JSON.parse(imSessionVarsService.getCurrentProviderSettings('GAP-Amount-Financed-States'));
        if (dealerStates != null ) {
            states = _.filter(dealerStates, function (n) {
                return n.Key == "States"
            })[0].Value;
        }
        return states;
    }
}]);
